const name = 'circle-i';

const contents = '<path fill="#FFF" d="M33.817 55h-5.634V26.829h5.634z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'I',
};

export default icon;
